// ============================================================
// Belge ve ödeme arayüzü (§4)
// ============================================================

import { esc, money } from "../lib/fmt.js";
import { ODEME_SAGLAYICILARI, belgeHTML, belgeVerisi, odemeBaglantisi } from "../domain/receipts.js";

/** Belgeyi yeni pencerede açar — tarayıcının PDF motoru kullanılır. */
export function belgeAc(student, inv, branchId) {
  const b = belgeVerisi(student, inv, branchId);
  const w = window.open("", "_blank", "width=820,height=1000");
  if (!w) return false;
  w.document.write(belgeHTML(b));
  w.document.close();
  return true;
}

/** Fatura satırındaki belge ve ödeme düğmeleri. */
export function belgeDugmeleri(student, inv, branchId, { kalan = 0 } = {}) {
  const odeme = kalan > 0 ? odemeBaglantisi(student, inv, branchId) : null;

  return `
  <span class="inline-flex items-center gap-1.5">
    <button data-belge="${student.id}:${inv.period}"
      class="rounded-lg border border-line bg-white text-[10px] font-semibold px-2 py-1 hover:bg-paper"
      title="Yazdır veya PDF olarak kaydet">
      📄 Belge
    </button>
    ${odeme ? `
      <button data-odemelink="${student.id}:${inv.period}"
        class="rounded-lg text-[10px] font-semibold px-2 py-1 transition
          ${odeme.hazir ? "bg-teal text-white hover:opacity-90" : "border border-line bg-white text-inksoft"}"
        title="${odeme.hazir ? `${odeme.label} ile öde` : `${odeme.label} entegrasyonu kurulmadı`}">
        💳 Öde${odeme.hazir ? "" : " ·kurulmadı"}
      </button>` : ""}
  </span>`;
}

/** Ayarlar'daki ödeme sağlayıcı kartı. */
export function odemeSaglayiciKarti() {
  return `
  <div class="p-5">
    <h2 class="font-display font-bold text-base mb-3">Online Ödeme</h2>
    <ul class="space-y-1.5">
      ${Object.values(ODEME_SAGLAYICILARI).map(s => `
        <li class="flex items-center gap-3 rounded-xl border border-line px-3 py-2">
          <span class="min-w-0 flex-1">
            <span class="block text-sm font-semibold">${esc(s.label)}</span>
            <span class="block text-[11px] text-inksoft">
              Komisyon ~%${(s.komisyon * 100).toFixed(2)} ·
              ${s.hazir ? "Kullanıma hazır" : "Entegrasyon kurulmadı"}
            </span>
          </span>
          <span class="text-[10px] font-bold rounded-full px-2 py-0.5 shrink-0
            ${s.hazir ? "bg-teal-soft text-teal" : "bg-line text-inksoft"}">
            ${s.hazir ? "Aktif" : "Pasif"}
          </span>
        </li>`).join("")}
    </ul>
    <p class="text-[11px] text-inksoft mt-3">
      Sağlayıcı entegrasyonu kurulmadığı için ödeme bağlantısı gerçek POS'a
      gitmiyor. Sahte bir "ödendi" akışı kurulmadı — para alındı sanmak,
      hiç almamaktan kötüdür. Kurulunca yalnızca bağlantı adresi değişir.
    </p>
  </div>`;
}

export { money };
